import type { TOC } from '@ember/component/template-only';
import IconComponent from '../icon/index.ts';

export interface BoxCodeSignature {
  Blocks: {
    default: [];
  };
  Element: null;
}

const BoxCodeComponent: TOC<BoxCodeSignature> = <template>
  <div class="flex items-center justify-between rounded-xl bg-primary-50 px-6 py-3">
    <IconComponent @name="lock" class="size-8" />
    <p class="text-body-base-semibold tracking-[.875em]">{{yield}}</p>
  </div>
</template>;

export default BoxCodeComponent;
